module.exports = __webpack_public_path__ + "cffb686d7d2f4682df8342bd4d276e09.woff2";